import { axiosInstance } from '../common/api';

export const sendForgotPasswordEmail = (data) => {
  const url = `/auth/forgotpassword`;
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, data)
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
